import { render, staticRenderFns } from "./addNew_PayGroup.vue?vue&type=template&id=2d42a9f2&scoped=true"
import script from "./addNew_PayGroup.vue?vue&type=script&lang=js"
export * from "./addNew_PayGroup.vue?vue&type=script&lang=js"
import style0 from "./addNew_PayGroup.vue?vue&type=style&index=0&id=2d42a9f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d42a9f2",
  null
  
)

export default component.exports